import React from 'react';
import styles from './EnjoyGames.module.css';
import icon from '../../../images/EnjoyGames/happy-mans-playing-playstation-Photoroom 1.webp'
import icon2 from '../../../images/EnjoyGames/happy-mans-playing-playstation-Photoroom 2.webp'
import  {motion} from 'framer-motion';

const EnjoyGames = ({openModal}) => {
    return (
        <motion.div initial={{ opacity: 0, y: -200 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true }}
                    className="p-6 bg-blue-500 text-white rounded-lg shadow-lg">
            <div className={styles.container}>
                <div className={styles.row_1}>
                    <h2>Грай зараз,<br/> <span style={{color: 'red'}}>відчувай</span> емоції!</h2>
                    <img src={icon2} alt=""/>
                    <p>Забудь про купівлю - орендуй і насолоджуйся іграми!</p>
                    <button onClick={() => openModal()} className='red-btn'>Отримати консоль</button>
                </div>
                <div className={styles.row_2}>
                    <img src={icon} alt=""/>
                </div>
            </div>
        </motion.div>
    );
};

export default EnjoyGames;